/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationSort } from '../models/ApplicationSort';
import type { MobileAppAuthRequirementResponse } from '../models/MobileAppAuthRequirementResponse';
import type { PaginatedResponse_UserApplicationSchema_ } from '../models/PaginatedResponse_UserApplicationSchema_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileApplicationsService {
    /**
     * Get mobile user applications
     * Get all active applications accessible to the authenticated mobile user
     * @param sort
     * @param xMobileAuth
     * @returns PaginatedResponse_UserApplicationSchema_ Successful Response
     * @throws ApiError
     */
    public static getMobileUserApplicationsV1(
        sort?: (ApplicationSort | null),
        xMobileAuth?: (string | null),
    ): CancelablePromise<PaginatedResponse_UserApplicationSchema_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/applications',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'sort': sort,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get an application's authentication requirement
     * Which ceremony the NewCore App must present before launching this application in the in-app browser. Advisory only — it does not authorize the launch.
     * @param appId
     * @param xMobileAuth
     * @returns MobileAppAuthRequirementResponse Successful Response
     * @throws ApiError
     */
    public static getMobileAppAuthRequirementV1(
        appId: string,
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileAppAuthRequirementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/applications/{app_id}/auth-requirement',
            path: {
                'app_id': appId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                403: `The launch is denied: the user is not assigned to the application, a policy blocks it, no policy matched, or the matched policy names no ceremony`,
                422: `Validation Error`,
                502: `The authentication requirement could not be resolved`,
            },
        });
    }
}
